import { fetchBaseQuery } from '@reduxjs/toolkit/query';

/**
 * Creates a base query function for Redux Toolkit's `fetchBaseQuery` with predefined settings.
 *
 * @param endpoint - The API endpoint to be appended to the base URL.
 * @returns A configured `fetchBaseQuery` function.
 *
 * The base URL is constructed using the `REACT_APP_BACKEND_URL` environment variable.
 * The `credentials` option is set to 'include' to include cookies in requests.
 * The `prepareHeaders` function adds an `Authorization` header with a Bearer token
 * if the `REACT_APP_BACKEND_API_TOKEN` environment variable is set.
 */
export const createBaseQuery = (endpoint: string) => {
  return fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
    credentials: 'include',
    prepareHeaders: (headers) => {
      const token = process.env.REACT_APP_BACKEND_API_TOKEN;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  });
};
